module.exports = __webpack_public_path__ + "static/media/profile_selected.7486e8e8.svg";